/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Test_RefusedInputs */

const th_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`บริการแจ้งเตือนปฏิเสธการส่งสำหรับ ${i?.count} อุปกรณ์ จะไม่มีการแจ้งเตือนมาถึง และไม่ได้เกิดจากการตั้งค่าอุปกรณ์ของคุณ`)
};

const en_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The push service refused it for ${i?.count} device(s). Nothing will arrive — this is not your device settings.`)
};

const ja_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プッシュサービスが${i?.count}台の端末への送信を拒否しました。通知は届きません。端末側の設定が原因ではありません。`)
};

const zh_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`推送服务对 ${i?.count} 台设备拒绝了它。什么都不会送达——这与你的设备设置无关。`)
};

const es_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El servicio push la ha rechazado en ${i?.count} dispositivo(s). No llegará nada; no es cosa de los ajustes de tu dispositivo.`)
};

const pt_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O serviço de push recusou em ${i?.count} dispositivo(s). Nada vai chegar — não são as configurações do seu aparelho.`)
};

const id_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Layanan push menolaknya untuk ${i?.count} perangkat. Tidak ada yang sampai — dan itu bukan soal pengaturan perangkat Anda.`)
};

const fr_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le service push l’a refusée pour ${i?.count} appareil(s). Rien n’arrivera — ce ne sont pas les réglages de votre appareil.`)
};

const tl_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tinanggihan ito ng push service para sa ${i?.count} device. Walang darating — at hindi iyon tungkol sa mga setting ng device mo.`)
};

const vi_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dịch vụ đẩy từ chối với ${i?.count} thiết bị. Sẽ không nhận được gì — và điều đó không liên quan tới thiết lập thiết bị của bạn.`)
};

const ko_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`푸시 서비스가 ${i?.count}개 기기에 대해 거부했습니다. 아무것도 도착하지 않으며, 기기 설정 문제가 아닙니다.`)
};

const de_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Push-Dienst hat sie für ${i?.count} Gerät(e) abgelehnt. Es kommt nichts an — das liegt nicht an deinen Geräteeinstellungen.`)
};

const ru_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Push-сервис отклонил их для ${i?.count} устройств. Ничего не придёт — и дело не в настройках вашего устройства.`)
};

const tr_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bildirim hizmeti bunu ${i?.count} cihaz için reddetti. Hiçbir şey ulaşmayacak — bu cihaz ayarlarınızla ilgili değil.`)
};

const it_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il servizio push le ha rifiutate per ${i?.count} dispositivi. Non arriverà nulla, e non dipende dalle impostazioni del tuo dispositivo.`)
};

const pl_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usługa push odrzuciła je dla ${i?.count} urządzeń. Nic nie dotrze — i nie chodzi o ustawienia twojego urządzenia.`)
};

const uk_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Служба push відхилила їх для ${i?.count} пристроїв. Нічого не надійде — і річ не в налаштуваннях вашого пристрою.`)
};

const hi_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पुश सेवा ने ${i?.count} उपकरणों के लिए इसे अस्वीकार कर दिया। कुछ नहीं पहुँचेगा — और यह आपके उपकरण की सेटिंग्स का मामला नहीं है।`)
};

const ar_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`رفضتها خدمة الإشعارات لـ ${i?.count} من الأجهزة. لن يصل شيء — وليس لذلك علاقة بإعدادات جهازك.`)
};

const ms_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perkhidmatan tolakan menolaknya untuk ${i?.count} peranti. Tiada apa akan sampai — dan ia bukan tentang tetapan peranti anda.`)
};

const bn_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`পুশ পরিষেবা ${i?.count}টি যন্ত্রের জন্য তা প্রত্যাখ্যান করেছে। কিছুই পৌঁছাবে না — এবং এটি আপনার যন্ত্রের সেটিংসের বিষয় নয়।`)
};

const zh_tw2_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`推播服務對 ${i?.count} 台裝置拒絕了它。什麼都不會送達——這與你的裝置設定無關。`)
};

const zh_hk2_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`推播服務對 ${i?.count} 台裝置拒絕了它。什麼都不會送達——這與你的裝置設定無關。`)
};

const ur_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`پُش سروس نے ${i?.count} آلات کے لیے اسے مسترد کر دیا۔ کچھ نہیں پہنچے گا — اور اس کا آپ کے آلے کی ترتیبات سے تعلق نہیں۔`)
};

const fa_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`سرویس اعلان آن را برای ${i?.count} دستگاه رد کرد. چیزی نمی‌رسد — و به تنظیمات دستگاه شما ربطی ندارد.`)
};

const sw_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Huduma ya arifa imezikataa kwa vifaa ${i?.count}. Hakuna kitakachofika — na haihusiani na mipangilio ya kifaa chako.`)
};

const nl_test_refused = /** @type {(inputs: Test_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`De pushdienst heeft ze geweigerd voor ${i?.count} apparaten. Er komt niets aan — en dat ligt niet aan je apparaatinstellingen.`)
};

/**
* | output |
* | --- |
* | "The push service refused it for {count} device(s). Nothing will arrive — this is not your device settings." |
*
* @param {Test_RefusedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_refused = /** @type {((inputs: Test_RefusedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_RefusedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_test_refused(inputs)
	if (locale === "ja") return ja_test_refused(inputs)
	if (locale === "zh") return zh_test_refused(inputs)
	if (locale === "es") return es_test_refused(inputs)
	if (locale === "pt") return pt_test_refused(inputs)
	if (locale === "id") return id_test_refused(inputs)
	if (locale === "fr") return fr_test_refused(inputs)
	if (locale === "tl") return tl_test_refused(inputs)
	if (locale === "vi") return vi_test_refused(inputs)
	if (locale === "ko") return ko_test_refused(inputs)
	if (locale === "de") return de_test_refused(inputs)
	if (locale === "ru") return ru_test_refused(inputs)
	if (locale === "tr") return tr_test_refused(inputs)
	if (locale === "it") return it_test_refused(inputs)
	if (locale === "pl") return pl_test_refused(inputs)
	if (locale === "uk") return uk_test_refused(inputs)
	if (locale === "hi") return hi_test_refused(inputs)
	if (locale === "ar") return ar_test_refused(inputs)
	if (locale === "ms") return ms_test_refused(inputs)
	if (locale === "bn") return bn_test_refused(inputs)
	if (locale === "zh-TW") return zh_tw2_test_refused(inputs)
	if (locale === "zh-HK") return zh_hk2_test_refused(inputs)
	if (locale === "ur") return ur_test_refused(inputs)
	if (locale === "fa") return fa_test_refused(inputs)
	if (locale === "sw") return sw_test_refused(inputs)
	if (locale === "nl") return nl_test_refused(inputs)
	return en_test_refused(inputs)
});